document.addEventListener("turbolinks:load", () => {
  // Copy Url button
  var $temp = $("<input>");
  var $url = $(location).attr('href');
  $('.copy-url').on('click', function(){
    $("body").append($temp);
    $temp.val($url).select();
    document.execCommand("copy");
    $temp.remove();
  });

  // Model filters
	$('form.model_filters').on('click', '.clear_filters', function(e) {
		$('form.model_filters input[type="number"]').val('');
		$('form.model_filters input[type="checkbox"]').prop('checked', false);
		//e.preventDefault();
	});

  $('form.model_filters').on('change', 'input[name^="filter"]', function(e) {
    $('form.model_filters').submit();
  });

   // Delete attachment file
  $('form').on('click', '.destroy_attachment', function(event){
    console.log('Delete attachment');
    checked = $(this).prop('checked');
    list_item = $(this).parent().parent().children("td").first();
    if(checked){
      list_item.css('text-decoration', 'line-through');
      list_item.addClass('destroy');
    }
    else {
      list_item.css('text-decoration', 'none');
      list_item.removeClass('destroy');
    }
  });

  $('form').on('submit', function(){
    $('table.attachments td.destroy').each(function(){
      $(this).children('input[type="hidden"]').remove();
    });
    $('table.prices td.destroy').each(function(){
      $(this).children('input[type="hidden"]').remove();
    });
  });
});
